import HeaderJson from './site-lookup-header.json';

class SiteLookupController {
    constructor(SiteLookupService) {
        'ngInject';

        this.SiteLookupService = SiteLookupService;
    }
    $onInit() {
        this.siteList = this.SiteLookupService.getSites();

        // data grid settings
        this.sortIndex = 0;
        this.headers = HeaderJson.headers;
        this.sortColumns = this.headers.filter((column) => column.showSort);
    }

    /***
     * sortList
     *  Sort the list of Sites based on "name" column.
     *  Iterates through 3 sort states, tracked by this.sortIndex:
     * 0 - no sort
     * 1 - sort ascending
     * 2 - sort descending
     *
     * @param sortColumnName    the column to sort the table by. Currently, the only option is "Client"
     */
    sortList(sortColumnName) {
        const sortColumn = this.sortColumns.filter((column) => column.text === sortColumnName)[0];
        if (sortColumn === undefined) {
            return;
        }
        if (this.sortPropDisplay !== sortColumnName) {
            this.sortIndex = 0;
        }
        this.sortPropDisplay = sortColumnName;
        this.sortIndex = (this.sortIndex + 1) % 3;
        this.isReverseSort = this.sortIndex === 2;
        this.sortProp = this.sortIndex === 0 ? null : sortColumn.nestedDisplayKeys.join('.');
    }

    /***
     * resetFilters
     *  Reset the column filters and display all results.
     */
    resetFilters() {
        this.search = {
            displayName: undefined,
            displaySiteID: undefined
        }
    }

    /***
     * updatePaginationStartingIndex
     *  A callback for the paginator component. Updates the ng-repeat list with the correct starting index, based on
     *  the current page.
     *
     * @param startingIndex     the index within the array of items to start displaying in the list.
     */
    updatePaginationStartingIndex(startingIndex) {
        this.startingIndex = startingIndex;
    }

}

export default SiteLookupController;



// WEBPACK FOOTER //
// ./app/components/site-lookup/site-lookup.controller.js